import React from 'react'
import classNames from 'classnames'
import generalClasses from './PlansComponent.module.css'
import businessPlansClasses from './BusinessPlans.module.css'
import { SubscriptionLoader } from '../loaders/SubscriptionLoader'
import { usePlans, BillingModes } from '../../hooks/usePlans'
import { OptionToggle } from '../OptionToggle/OptionToggle'
import Carousel from '../Carousel/Carousel'
import { UserTypes } from '../../util/constants'
import { convertToFormatted } from '../../util/functions'
import { Button } from '../Button/Button'

const classes = { ...generalClasses, ...businessPlansClasses }

const PlanCard = ({
    title,
    price,
    cycle,
    description,
    buttonBg = '#EB6324',
    features,
    className,
    onSelect,
    beneficiaryCount,
}) => (
    <section className={classNames(classes.plan, className)}>
        <h5 className={classes.planName}>{title}</h5>
        <p className={classes.planPrice}>{convertToFormatted(price)}</p>
        <p className={classes.planCycle}>{cycle}</p>
        <p className={classes.planCycle}>Staff Count: {beneficiaryCount}</p>
        <p className={classes.planDescription}>{description}</p>
        <Button
            style={{
                backgroundColor: buttonBg,
                borderColor: buttonBg,
            }}
            onClick={onSelect}
        >
            Select Plan
        </Button>
        <h6 className={classes.planFeaturesHeader}>Plan Includes</h6>
        <ul className={classes.planFeatures}>
            {features.map((feature, idx) => (
                <li key={idx} className={classes.planFeature}>
                    {feature}
                </li>
            ))}
        </ul>
    </section>
)

export function BusinessPlans({ className, onSelect }) {
    const {
        isFetching,
        changeBillingMode,
        billingMode,
        plans,
        onSelectPlan,
    } = usePlans(UserTypes.Business)

    const options = {
        left: BillingModes.Annually,
        right: BillingModes.Monthly,
    }

    const content = isFetching
        ? [1, 2].map(i => <SubscriptionLoader key={i} />)
        : plans.map(plan => (
              <PlanCard
                  key={plan.subid}
                  title={plan.title}
                  price={plan.amount}
                  cycle={plan.cycle}
                  beneficiaryCount={plan.beneficiarycount}
                  description={plan.description}
                  features={plan.features}
                  onSelect={() =>
                      !!onSelect ? onSelect(plan) : onSelectPlan(plan)
                  }
                  className={classes.planItem}
              />
          ))

    return (
        <div className={classNames(classes.plans, className)}>
            <OptionToggle
                options={options}
                activeOption={billingMode}
                onChangeOption={changeBillingMode}
                className={classes.billingMode}
            />
            <div className={classes.plansGrid}>{content}</div>
            <div className={classes.plansCarousel}>
                <Carousel
                    slideClassName={classes.planSlideWrapper}
                    dots
                    dotBg={'#EB6324'}
                    dotClass={classes.dot}
                >
                    {content}
                </Carousel>
            </div>
        </div>
    )
}
